import { _ as _sfc_main } from "../../MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import { resolveComponent, openBlock, createBlock, withCtx, createVNode, mergeProps, resolveDynamicComponent, normalizeProps, guardReactiveProps, createElementVNode, toDisplayString, withDirectives, createTextVNode, vShow } from "vue";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-3194dc60.mjs";
import "../../helpers-674591c1.mjs";
import "joi";
import "../../_commonjsHelpers-ca272635.mjs";
import "../../malarkeyTwilioAdapter-1c296255.mjs";
import "../../index-13be80af.mjs";
import "../../_debug-8b5c3032.mjs";
import "../../_VListItem-508e4b13.mjs";
import "../../_density-8094aebe.mjs";
import "../../MalarkeyContactAvatar-1b079ba3.mjs";
import "../../_proxiedModel-031e293c.mjs";
import "../../index-64135f7d.mjs";
import "../../i18n-35335a5c.mjs";
import "../../index-38c53cf2.mjs";
import "../../_i18n-e414d464.mjs";
import "../../index-703c58ee.mjs";
import "../../event-socket/malarkeyEventSocketAdapter.es.js";
import "../../otpauth.esm-675c01d0.mjs";
import "../../sudo-bad5b55e.mjs";
import "../../index-fd2245c5.mjs";
import "../../theme-96176369.mjs";
import "../../getCurrentInstance-eec76705.mjs";
const _hoisted_1 = ["textContent"];
const _hoisted_2 = ["textContent"];
const _hoisted_3 = /* @__PURE__ */ createElementVNode("span", { class: "m-cli-text-spacer" }, " ", -1);
const _hoisted_4 = { class: "d-flex flex-column align-end" };
const _hoisted_5 = ["textContent"];
const _hoisted_6 = { class: "d-flex" };
const _hoisted_7 = { class: "flex-grow-1" };
const _hoisted_8 = { class: "flex-grow-1" };
const _hoisted_9 = ["textContent"];
const _hoisted_10 = /* @__PURE__ */ createElementVNode("span", { class: "flex-grow-0 m-cli-text-spacer" }, " ", -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_list_item_subtitle = resolveComponent("v-list-item-subtitle");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  return openBlock(), createBlock(_component_v_tooltip, { text: _ctx.title }, {
    activator: withCtx(({ props }) => [
      createVNode(_component_v_list_item, mergeProps({ ..._ctx.vListItemBindings, ...props }, {
        onClick: _ctx.onClick,
        onContextmenu: _ctx.onContextMenu,
        ref: "mConversationListItem"
      }), {
        prepend: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.avatarComponent), normalizeProps(guardReactiveProps(_ctx.avatarComponentBindings)), null, 16))
        ]),
        append: withCtx(() => [
          createElementVNode("div", _hoisted_4, [
            createElementVNode("div", null, [
              createElementVNode("span", {
                class: "m-cli-label m-cli-last-updated",
                textContent: toDisplayString(_ctx.lastUpdated)
              }, null, 8, _hoisted_5)
            ]),
            createElementVNode("div", _hoisted_6, [
              createElementVNode("div", _hoisted_7, [
                withDirectives(createVNode(_component_v_icon, { size: "small" }, {
                  default: withCtx(() => [
                    createTextVNode("mdi-volume-off")
                  ]),
                  _: 1
                }, 512), [
                  [vShow, _ctx.isMuted]
                ])
              ]),
              createElementVNode("div", _hoisted_8, [
                withDirectives(createVNode(_component_v_chip, {
                  density: "compact",
                  size: "small",
                  color: "notify",
                  variant: "flat",
                  class: "m-cli-unread-count-chip"
                }, {
                  default: withCtx(() => [
                    createElementVNode("span", {
                      class: "m-cli-unread-count font-weight-bold",
                      textContent: toDisplayString(_ctx.unreadMessageCount)
                    }, null, 8, _hoisted_9)
                  ]),
                  _: 1
                }, 512), [
                  [vShow, _ctx.hasUnreadMessages]
                ])
              ]),
              _hoisted_10
            ])
          ])
        ]),
        default: withCtx(() => [
          createElementVNode("div", mergeProps({
            class: "m-cli-menu-anchor",
            ref: "mConversationListItemMenuAnchor"
          }, _ctx.contextMenuAnchorBinding), null, 16),
          createVNode(_component_v_list_item_title, null, {
            default: withCtx(() => [
              createElementVNode("strong", {
                textContent: toDisplayString(_ctx.title)
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          createVNode(_component_v_list_item_subtitle, null, {
            default: withCtx(() => [
              createElementVNode("span", {
                class: "m-cli-label m-cli-last-message-preview",
                textContent: toDisplayString(_ctx.lastMessagePreview)
              }, null, 8, _hoisted_2),
              _hoisted_3
            ]),
            _: 1
          }),
          createVNode(_component_v_menu, mergeProps({
            modelValue: _ctx.showContextMenu,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.showContextMenu = $event)
          }, _ctx.contextMenuBindings), {
            default: withCtx(() => [
              createVNode(_component_v_card, null, {
                default: withCtx(() => [
                  _ctx.hasUnreadMessages ? (openBlock(), createBlock(_component_v_list_item, {
                    key: 0,
                    title: _ctx.$t("malarkeyConversationListItem.actions.markAllAsRead"),
                    "prepend-icon": "mdi-eye-check-outline",
                    onClick: _ctx.setAllMessagesRead
                  }, null, 8, ["title", "onClick"])) : (openBlock(), createBlock(_component_v_list_item, {
                    key: 1,
                    title: _ctx.$t("malarkeyConversationListItem.actions.markAllAsUnread"),
                    "prepend-icon": "mdi-eye-remove-outline",
                    onClick: _ctx.setAllMessagesUnread
                  }, null, 8, ["title", "onClick"])),
                  createVNode(_component_v_divider),
                  _ctx.isMuted ? (openBlock(), createBlock(_component_v_list_item, {
                    key: 2,
                    title: _ctx.$t("malarkeyConversationListItem.actions.unmute"),
                    "prepend-icon": "mdi-volume-high",
                    onClick: _ctx.setConversationUnmuted
                  }, null, 8, ["title", "onClick"])) : (openBlock(), createBlock(_component_v_list_item, {
                    key: 3,
                    title: _ctx.$t("malarkeyConversationListItem.actions.mute"),
                    "prepend-icon": "mdi-volume-off",
                    onClick: _ctx.setConversationMuted
                  }, null, 8, ["title", "onClick"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 16, ["modelValue"])
        ]),
        _: 2
      }, 1040, ["onClick", "onContextmenu"])
    ]),
    _: 1
  }, 8, ["text"]);
}
const MalarkeyConversationListItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyConversationListItem.vue"]]);
export {
  MalarkeyConversationListItem as default
};
//# sourceMappingURL=MalarkeyConversationListItem.es.js.map
